import { Observable } from 'rxjs';

export const elementResize = (el: Element) =>
  new Observable<DOMRectReadOnly>((observer) => {
    const resizer = new ResizeObserver((entries) => {
      window.requestAnimationFrame(() => {
        if (entries[0]) {
          observer.next(entries[0].contentRect);
        }
      });
    });
    resizer.observe(el);
    observer.add(() => resizer.unobserve(el));
  });
